import { render, staticRenderFns } from "./OdocLocationsInput.vue?vue&type=template&id=18012510"
import script from "./OdocLocationsInput.vue?vue&type=script&lang=js"
export * from "./OdocLocationsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports